<template>
  <div>
    <div v-if="isLoadingPage">
      <transition name="slide-fade">
        <div class="loading-integreat" v-if="isLoadingPage">
          <div class="initial-load-animation">
            <div class="linkedin-image"></div>
            <div class="loading-bar">
              <div class="blue-bar"></div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-else>
      <div class="pd-b-20">
        <!-- <b-loading :active.sync="isLoadingPage"></b-loading> -->

        <div class="columns m-h-auto">
          <div class="column is-7">
            <p
              class="title pd-t-15 is-size-4-tablet is-size-5-mobile has-text-weight-normal"
            >
              Dashboard
            </p>
          </div>
          <div class="column dashboard-select">
            <div class="columns m-h-auto is-vcentered is-justify-end">
              <div class="">
                <div class="has-text-centered-mobile">Overview of</div>
              </div>
              <div class="column">
                <b-field>
                  <b-select v-model="startRage" placeholder="year" expanded>
                    <option value="Overall">Overall</option>
                    <option
                      :disabled="data > endRage"
                      :value="data"
                      v-for="(data, index) in fiscalYear"
                    >
                      {{ data }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="">to</div>
              <div class="column">
                <b-field>
                  <b-select
                    v-model="endRage"
                    placeholder="Select end year"
                    expanded
                  >
                    <option value="Overall">Overall</option>
                    <option
                      :disabled="data < startRage"
                      :value="data"
                      v-for="(data, index) in fiscalYearMax"
                    >
                      {{ data }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="mg-r-15">
                <button class="button" @click="fetchRangDataCronJob()">
                  <span>View</span>
                </button>
              </div>
            </div>
            <!--  <b-datepicker type="month" placeholder="All" :max-date="endRage"  v-model="startRage" icon="calendar-alt" icon-pack="fas"></b-datepicker> -->
          </div>
          <!-- <div class="has-text-centered-mobile">to</div>
          <div class="column">
            <b-field>
              <b-datepicker type="month" :min-date="startRage" placeholder="All" min v-model="endRage" icon="calendar-alt" icon-pack="fas"></b-datepicker>
            </b-field>
          </div> -->
        </div>
        <div class="columns m-h-auto">
          <div class="column has-text-right pd-y-0 th is-size-7">
            <div class="done-color">
              ข้อมูลอัพเดทล่าสุดเมื่อ {{ formateDate(new Date()) }}
            </div>
          </div>
        </div>
        <div class="columns m-h-auto">
          <div class="column is-6 m-h-300">
            <div class="box-border has-background-white box-h-max h-100">
              <div class="mg-b-5 line-title-dh">
                <p class="is-size-5 has-text-weight-normal pd-10">
                  Project Overview
                </p>
              </div>
              <div
                class="columns m-h-auto"
                v-if="
                  Object.values(allData).length &&
                  allData.company.allCompanies > 0
                "
              >
                <div class="column is-5 mg-l-auto">
                  <Pie
                    :width="200"
                    :height="200"
                    :labels="[
                      'In active',
                      'In process',
                      'Acheived',
                      'Deactive',
                      'Succeed',
                    ]"
                    :bgColor="[
                      '#b5b5b5',
                      '#04DB51',
                      '#209cee',
                      '#b5b5b5',
                      '#00a79d',
                    ]"
                    :numData="chartData"
                    :tooltipsOpen="true"
                  />
                  <p
                    class="has-text-centered is-size-2 has-text-weight-bold"
                    v-if="typeof allData.company.allCompanies != 'undefined'"
                  >
                    {{ allData.company.allCompanies }}
                  </p>
                  <p class="has-text-centered has-text-weight-semibold">
                    All Projects
                  </p>
                </div>
                <div class="column is-5">
                  <div class="pd-20">
                    <p
                      class="is-size-7 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
                    >
                      <b-icon
                        pack="fas"
                        icon="circle"
                        class="has-text-grey-light"
                      ></b-icon
                      >In active: {{ allData.company.inactive }} Projects
                    </p>
                    <p
                      class="is-size-7 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
                    >
                      <b-icon
                        pack="fas"
                        icon="circle"
                        class="has-text-success"
                      ></b-icon
                      >In process: {{ allData.company.inprocess }} Projects
                    </p>
                    <p
                      class="is-size-7 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
                    >
                      <b-icon
                        pack="fas"
                        icon="circle"
                        class="has-text-info"
                      ></b-icon
                      >Acheived: {{ allData.company.acheived }} Projects
                    </p>
                    <p
                      class="is-size-7 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
                    >
                      <b-icon
                        pack="fas"
                        icon="circle"
                        class="done-color"
                      ></b-icon
                      >Succeed: {{ allData.company.succeed }} Projects
                    </p>
                    <p
                      class="is-size-7 has-text-dark is-flex is-align-center pd-5 has-text-weight-normal"
                    >
                      <b-icon
                        pack="fas"
                        icon="circle"
                        class="has-text-grey-light"
                      ></b-icon
                      >Deactive: {{ allData.company.deactive }} Projects
                    </p>
                  </div>
                </div>
              </div>
              <div class="" v-else>
                <div
                  class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
                >
                  <p>*** {{ $t("dashboard.notfound") }} ***</p>
                </div>
              </div>
              <div class="mg-b-5 line-title-dh mg-t-40">
                <p class="is-size-5 has-text-weight-normal pd-10">
                  Performance
                </p>
              </div>
              <div class="mg-20 pd-20">
                <div
                  class="columns m-h-auto mg-20"
                  v-if="
                    Object.values(allData).length > 0 &&
                    (allData.task.percentDone > 0 ||
                      allData.task.percentOverdue > 0)
                  "
                >
                  <div
                    class="column is-paddingless"
                    :class="user.userLevel == 85 ? 'border-right-solid' : ''"
                  >
                    <p
                      class="is-size-2 has-text-weight-normal has-text-centered th done-color"
                    >
                      {{
                        ((allData.task.done * 100) / allData.task.allTask)
                          | floatNumber
                      }}%
                    </p>
                    <p class="is-size-6 th has-text-centered done-color">
                      Task ที่เสร็จแล้ว
                    </p>
                  </div>
                  <div
                    class="column is-paddingless"
                    v-if="user.userLevel == 85"
                  >
                    <p
                      class="is-size-2 has-text-weight-normal has-text-centered th overdue-color"
                    >
                      {{ allData.task.percentOverdue | floatNumber }}%
                    </p>
                    <p class="is-size-6 th has-text-centered overdue-color">
                      Task ที่ล่าช้า
                    </p>
                  </div>
                </div>
                <div v-else>
                  <div
                    class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
                  >
                    <p>*** {{ $t("dashboard.notfound") }} ***</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div
              class="m-h-300 box-border has-background-white box-h-max pd-b-20 h-100"
            >
              <div class="mg-b-5 line-title-dh">
                <p class="is-size-5 has-text-weight-normal pd-10">
                  All investments
                </p>
              </div>
              <div
                class="columns m-h-auto is-flex-wrap"
                v-if="invest.length > 0"
              >
                <!--          <div v-for="(item,index) in invest"  class="column is-6 pd-10" >
              <div class="is-flex is-justify-spacebetween mg-b-5">
                <p class="is-size-6 th" :title="item.name">{{item.name | snippetMilestone}}</p>
                <p v-if="under.underCode === 'B001' || under.underCode === 'B002' || getRule === 'board'" class="is-size-6 has-text-weight-semibold done-color" title="Pending">{{item.amount | commaNumber }} ฿</p>
                <p v-else class="is-size-6 has-text-weight-semibold done-color" title="Pending">{{item.percent | floatNumber }}%</p>
              </div>
              <div class="line-progress-success" :style="'width:'+item.percent+'%'"></div>
              <div class="line-progress"></div>
            </div> -->
                <div class="column is-6 pd-b-15">
                  <!--               <Doughnut
                  :width="220"
                  :height="220"
                  :labels="labelName"
                  :bgColor="getColor()"
                  :timeout="2"
                  :numData="labelvalue"
                  :tooltipsOpen="true"
                  :unitLabel="(under.underCode === 'B001' || under.underCode === 'B002' || getRule === 'board')?'บาท':'%'"
              /> -->
                  <Stacked
                    :width="200"
                    :height="450"
                    :labels="['All investments']"
                    :bgColor="getColor()"
                    :timeout="2"
                    :numData="labelvalue"
                    :tooltipsOpen="true"
                    :unitLabel="
                      under.underCode === 'B001' ||
                      under.underCode === 'B002' ||
                      getRule === 'board'
                        ? 'บาท'
                        : '%'
                    "
                  />
                </div>
                <div class="column is-6 scrollChart">
                  <div
                    v-for="(value, index) in labelName"
                    :key="index"
                    class="is-flex is-align-center th has-text-grey"
                  >
                    <b-icon
                      pack="fas"
                      icon="circle"
                      :style="{ color: getColor()[index] }"
                    ></b-icon
                    ><span
                      v-if="
                        under.underCode === 'B001' ||
                        under.underCode === 'B002' ||
                        getRule === 'board'
                      "
                      >{{ labelvalue[index].data | commaNumber }} บาท</span
                    ><span v-else
                      >{{ labelvalue[index].data | floatNumber }}% </span
                    >&nbsp;{{ value }}
                  </div>
                </div>
              </div>
              <div class="" v-else>
                <div
                  class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
                >
                  <p>*** {{ $t("dashboard.notfound") }} ***</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns m-h-auto">
          <!--       <div class="column is-6 m-h-300">
        <div class="box-border has-background-white box-h-max h-100">
          <div class="mg-b-5 line-title-dh">
            <p class="is-size-5 has-text-weight-normal pd-10">Performance</p>
          </div>
          <div class="mg-20 pd-20 ">
            <div class="columns m-h-auto mg-20" v-if="Object.values(allData).length > 0 &&( allData.task.percentDone > 0 || allData.task.percentOverdue > 0)">
              <div class="column is-paddingless" :class="user.userLevel == 85 ? 'border-right-solid' : ''">
                <p class="is-size-2 has-text-weight-normal has-text-centered th done-color">{{ (allData.task.done*100)/allData.task.allTask | floatNumber}}%</p>
                <p class="is-size-6 th has-text-centered done-color">Task ที่เสร็จแล้ว</p>
              </div>
              <div class="column is-paddingless" v-if="user.userLevel == 85">
                <p class="is-size-2 has-text-weight-normal has-text-centered th overdue-color">{{allData.task.percentOverdue | floatNumber}}%</p>
                <p class="is-size-6 th has-text-centered overdue-color">Task ที่ล่าช้า</p>
              </div>
            </div>
            <div v-else> 
              <div
                class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
              >
                <p>*** {{ $t("dashboard.notfound") }} ***</p>
              </div>
            </div>
          </div>
        </div>
      </div> -->
          <div class="column is-12 m-h-300">
            <div class="box-border has-background-white box-h-max h-100">
              <div class="">
                <div
                  class="columns is-flex-wrap is-flex is-justify-spacebetween m-h-auto mg-b-5 line-title-dh"
                >
                  <div class="column is-two-thirds-mobile is-paddingless is-8">
                    <p
                      class="is-size-5 is-size-6-mobile has-text-weight-normal pd-10"
                    >
                      Performance Support
                    </p>
                  </div>
                  <div class="column is-paddingless is-4">
                    <p
                      v-if="Object.values(allData).length > 0"
                      class="is-size-5 is-size-6-mobile has-text-right has-text-weight-normal pd-10"
                    >
                      {{ allData.activities }} Activities
                    </p>
                  </div>
                </div>
              </div>
              <div class="pd-b-20 h-100-per">
                <div
                  class="columns m-h-auto is-flex-wrap"
                  v-if="invest.length > 0"
                >
                  <div
                    v-for="(item, index) in invest.length > 3
                      ? 3
                      : invest.length"
                    :class="{ 'is-hidden-mobile': index > 0 ? true : false }"
                    class="column is-flex-wrap mg-t-10 is-4"
                  >
                    <div
                      class="columns pd-10 m-h-auto is-flex-wrap is-flex is-justify-spacebetween"
                    >
                      <div
                        class="column is-10 is-four-fifths-mobile is-paddingless"
                      >
                        <p class="is-size-6 is-paddingless th has-text-grey">
                          Category
                        </p>
                      </div>
                      <div class="column is-2 has-text-centered is-paddingless">
                        <p class="is-size-6 has-text-grey">Activity</p>
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="(item, index) in invest"
                    :key="index"
                    class="column is-flex-wrap is-4 pd-y-0 mg-b-20"
                  >
                    <div
                      class="columns is-flex is-justify-spacebetween pd-10 m-h-auto is-flex-wrap"
                    >
                      <div
                        class="column is-10 is-four-fifths-mobile m-h-auto is-paddingless"
                      >
                        <p class="is-size-6 th" :title="item.name">
                          {{ item.name | snippetMilestone }}
                        </p>
                      </div>
                      <div class="column is-2 has-text-centered is-paddingless">
                        <p class="is-size-6 has-text-weight-bold done-color">
                          {{ item.activities }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
                >
                  <div>
                    <p>*** {{ $t("dashboard.notfound") }} ***</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns m-h-auto">
          <div class="column m-h-300">
            <div class="box-border has-background-white box-h-max">
              <div class="mg-b-5 line-title-dh">
                <p class="is-size-5 has-text-weight-normal pd-y-10">
                  Business growth
                </p>
              </div>
              <b-tabs
                v-if="Object.keys(kpiAllData).length > 0"
                v-model="activeTab"
                size="is-large"
                @change="changTap()"
              >
                <b-tab-item :visible="false"></b-tab-item>
                <b-tab-item
                  class="pd-y-20"
                  v-for="(value, index) in kpiAllData"
                  :key="index"
                  :label="value.name"
                >
                  <template slot="header">
                    <div class="has-text-centered d-grid">
                      <span v-if="$i18n.locale === 'th'" class="th">{{
                        value.name
                      }}</span>
                      <span v-else>{{ getLabelNameChartEN(value.name) }}</span>

                      <span class="is-size-5">
                        <span
                          v-if="
                            value.value.length > 1 &&
                            Math.abs(value.percent) !== 0
                          "
                        >
                          <span v-show="value.percent > 0">
                            <i
                              class="fas fa-angle-up has-text-primary-green mg-t-5"
                            ></i>
                          </span>
                          <span v-show="value.percent < 0">
                            <i
                              class="fas fa-angle-down has-text-danger-status mg-t-5"
                            ></i>
                          </span>
                          <span
                            class="is-size-6 has-text-weight-semibold"
                            :class="
                              value.percent > 0
                                ? 'has-text-primary-green'
                                : ' has-text-danger-status'
                            "
                          >
                            {{ Math.abs(value.percent) }}%
                          </span>
                        </span>
                        <span class="is-size-6 has-text-weight-semibold"
                          >({{
                            value.value[value.value.length - 1] | commaNumber
                          }}
                          <span v-if="$i18n.locale === 'th'" class="th">{{
                            value.name !== "การจ้างงาน(คน)" ? "บาท" : "คน"
                          }}</span
                          ><span v-else>{{
                            value.name !== "การจ้างงาน(คน)" ? "baht" : "people"
                          }}</span
                          >)</span
                        >
                      </span>
                    </div>
                  </template>
                  <LineChart
                    v-if="renderLineChart === true"
                    :height="350"
                    :width="450"
                    :bdColor="'#00a79d'"
                    :labels="value.label"
                    :numData="value.value"
                    :unitLabel="getLabelNameChartSuffix(value.name)"
                    :commaY="true"
                  />
                </b-tab-item>
              </b-tabs>
              <div
                v-else
                class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center"
              >
                <p>*** {{ $t("dashboard.notfound") }} ***</p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="columns m-h-auto is-flex-wrap">
      <div class="column is-12 m-h-auto">
        <div class="box-border has-background-white-grey pd-x-15 box-h-max">
          <div class="column is-offset-9 is-3">
            <b-field label>
              <b-input></b-input>
            </b-field>
          </div>
          <div class="columns m-h-auto">
            <div class="column is-offset-1 is-2 has-text-centered" @click="sortBy('organizeName')">
              <p
                class="is-size-7 has-text-weight-semibold cr-pointer"
                :class="{'has-text-secondary':currentSort === 'organizeName'}"
              >
                Department
                <span
                  class="arrow"
                  :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                  v-show="currentSort == 'organizeName'"
                ></span>
              </p>
            </div>
            <div class="column is-1 has-text-centered" @click="sortBy('typeOfIndustry')">
              <p
                class="is-size-7 has-text-weight-semibold cr-pointer"
                :class="{'has-text-secondary':currentSort === 'typeOfIndustry'}"
              >
                Funding
                <span
                  class="arrow"
                  :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                  v-show="currentSort == 'typeOfIndustry'"
                ></span>
              </p>
            </div>
            <div class="column is-offset-1 is-4 has-text-centered" @click="sortBy('statusTask')">
              <p
                class="is-size-7 has-text-weight-semibold cr-pointer"
                :class="{'has-text-secondary':currentSort === 'statusTask'}"
              >
                Operation overview
                <span
                  class="arrow"
                  :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
                  v-show="currentSort == 'statusTask'"
                ></span>
              </p>
            </div>
          </div>
          <div class="columns detail-table is-margin-x-not is-vcentered pd-y-5">
            <div class="column is-1" data-label="organizeName">
              <div class="column is-6 has-text-centered pd-col-fixed">
                <figure class="image box-circle-s">
                  <img
                    class="is-rounded"
                    src="https://bulma.io/images/placeholders/64x64.png"
                    alt="Placeholder image"
                  >
                </figure>
              </div>
            </div>
            <div class="column is-2 has-text-centered has-text-weight-bold" data-label=" ">
              <p class="is-size-6">Ubon ratchathani</p>
              <p class="is-size-6">University Science Park</p>
            </div>
            <div class="column is-1 has-text-centered" data-label>
              <p class="is-size-6 has-text-weight-bold">SIZE M</p>
            </div>
            <div class="column is-1" data-label>
              <p class="is-size-4 has-text-weight-bold">78.0M</p>
            </div>
            <div class="column is-4" data-label>
              <div class="columns pd-y-10 is-flex-wrap m-h-auto">
                <div class="column mg-b-5 is-paddingless is-6">
                  <p class="is-size-7 has-text-weight-bold">Agriculture and food</p>
                  <p class="is-size-7">฿153.0M of ฿330.3M</p>
                </div>
                <div class="column mg-b-5 is-paddingless is-6">
                  <p class="is-size-7 has-text-weight-bold">Medical and Biotechnology</p>
                  <p class="is-size-7">฿153.0M of ฿330.3M</p>
                </div>
                <div class="column mg-b-5 is-paddingless is-6">
                  <p class="is-size-7 has-text-weight-bold">Agriculture and food</p>
                  <p class="is-size-7">฿153.0M of ฿330.3M</p>
                </div>
                <div class="column mg-b-5 is-paddingless is-6">
                  <p class="is-size-7 has-text-weight-bold">Medical and Biotechnology</p>
                  <p class="is-size-7">฿153.0M of ฿330.3M</p>
                </div>
              </div>
            </div>
            <div class="column is-1 has-text-centered" data-label>
              <p class="is-size-5 has-text-weight-bold done-color">63.0%</p>
              <p class="is-size-7">Percentage progress of the plan</p>
            </div>
            <div class="column is-1" data-label>
              <p class="is-size-6 has-text-weight-bold">2.3</p>
              <p class="is-size-7">Actual Plan</p>
              <p class="is-size-7 has-text-weight-bold">Employment</p>
            </div>
            <div class="column is-1" data-label>
              <p class="is-size-6 has-text-weight-bold">0.1/0.5M฿</p>
              <p class="is-size-7">Actual Plan</p>
              <p class="is-size-7 has-text-weight-bold">Revenue</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Stacked from "../charts/StackedChart";
import Doughnut from "../charts/Doughnut";
import { HTTP } from "../axios.js";
import Pie from "../charts/PieChart";
import LineChart from "../charts/LineChart";
import { setTimeout } from "timers";
import moment from "moment";
import momentTH from "moment/src/locale/th";
export default {
  data() {
    return {
      chartData: [],
      heightChart: 0,
      fiscalYear: [],
      fiscalYearMax: [],
      startYear: new Date().getFullYear() + 544,
      endYear: new Date().getFullYear() + 543 - 2557,
      widthMax: window.innerWidth,
      isLoadingPage: null,
      activitysAllStartup: [],
      tasksAllStartup: [],
      isDetailWorkToday: false,
      isDetailWorkTodaySuccess: false,
      staffLink: null,
      startupLink: null,
      isSpa: null,
      kpiArray: {},
      activeTab: 1,
      renderLineChart: true,
      kpiAll: [],
      startRage: "Overall",
      endRage: "Overall",
      allData: [],
      invest: [],
      under: {},
      labelName: [],
      labelvalue: [],
    };
  },
  components: {
    Stacked,
    Pie,
    LineChart,
    Doughnut,
  },
  mounted() {
    setTimeout(() => {
      this.isLoadingPage = false;
    }, 2500);
    this.getYear();
  },
  methods: {
    getLabelNameChartEN(text) {
      if (text === "รายได้(บาท)") {
        return `Revenue (baht)`;
      } else if (text === "การจ้างงาน(คน)") {
        return `Employment (people)`;
      } else {
        return `Investment (baht)`;
      }
    },
    getLabelNameChartSuffix(text) {
      if (text === "การจ้างงาน(คน)") {
        if (this.$i18n.locale === "th") {
          return `คน`;
        } else {
          return `people`;
        }
      } else {
        if (this.$i18n.locale === "th") {
          return `บาท`;
        } else {
          return `baht`;
        }
      }
    },

    getYear() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post("/api/get/fiscal/year", { underId: this.user.under })
        .then((result) => {
          //console.log('/api/get/under/by/id',result)
          this.fiscalYear = result.data;
          let max = JSON.stringify(result.data);
          this.fiscalYearMax = JSON.parse(max);
          this.fiscalYearMax = this.fiscalYearMax.sort((a, b) => {
            if (a > b) return -1;
            return 0;
          });
        })
        .catch((e) => {
          console.log("/api/get/fiscal/year", e);
          this.isLoadingPage = false;
        });
    },
    formateDate(value) {
      if (new Date().getHours() < 3) {
      }
      if (value) {
        if (new Date().getHours() < 3) {
          //return t.add(-1,'day').format("DD MMMM YYYY เวลา 03:00 น.");
          return moment(
            moment(value).locale("th", momentTH).add(-1, "day").add(543, "y")
          ).format("DD MMMM YYYY เวลา 03:00 น.");
        } else {
          return moment(
            moment(value).locale("th", momentTH).add(543, "y")
          ).format("DD MMMM YYYY เวลา 03:00 น.");
        }
      } else {
        return "";
      }
    },
    async getUnder() {
      let data = {
        underId: this.user.under,
      };
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post("/api/get/under/by/id", data)
        .then((result) => {
          //console.log('/api/get/under/by/id',result)
          this.under = result.data;
        })
        .catch((e) => {
          console.log("/api/get/under/by/id", e);
          this.isLoadingPage = false;
        });
    },
    getPercentGrowth(last, before) {
      let num = last - before;
      let sum = num / before;
      let percent = sum * 100;
      if (isFinite(percent) === true) {
        return Number(percent.toFixed(2));
      } else {
        return 0;
      }
    },
    fetchKpiStartupAll() {
      this.renderLineChart = false;
      for (let index = 0; index < this.startupLists.length; index++) {
        setTimeout(() => {
          this.fetchKpiAll(this.startupLists[index].startUpId);
        }, 500 * index);
      }
      setTimeout(() => {
        this.renderLineChart = true;
      }, 3000);
    },
    async fetchRangDataCronJob() {
      this.isLoadingPage = true;
      let data = {
        url: "/api/get/dashboard/fiscal/year",
        underId: this.user.userLevel == 90 ? this.user.under : "",
        scienceParkId: this.user.userLevel == 85 ? this.user.scienceParkId : "",
        start: this.startRage !== "Overall" ? this.startRage : "Overall",
        end: this.endRage !== "Overall" ? this.endRage : "Overall",
      };
      //console.log("api/get/cron/job/dashboard",data)
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post(data.url, data)
        .then((res) => {
          if (res.data.success) {
            this.chartData = [];
            this.allData = res.data.obj.data;
            this.chartData.push(this.allData.company.inactive);
            this.chartData.push(this.allData.company.inprocess);
            this.chartData.push(this.allData.company.acheived);
            this.chartData.push(this.allData.company.deactive);
            this.chartData.push(this.allData.company.succeed);
            //console.log('this.chartData',this.chartData)
            this.getInvestments();
            this.kpiAll = [];
            this.kpiArray = [];
            if (res.data.obj.data.kpi.length > 0) {
              res.data.obj.data.kpi.map((dataKpi, num) => {
                Object.keys(dataKpi.kpi).forEach((key) => {
                  if (
                    dataKpi.kpi[key].repeat != null &&
                    typeof dataKpi.kpi[key].repeat != "undefined"
                  ) {
                    let count = 1;
                    let futureCount = 1;
                    let q = 1;
                    let repeatDate = new Date(2019, 0, 1);
                    let repeatStartNum = repeatDate.getMonth();
                    let repeatDateFuture = new Date(
                      dataKpi.kpi[key].repeat.repeatStart
                    );
                    repeatDateFuture = new Date(
                      repeatDateFuture.setMonth(
                        repeatStartNum +
                          dataKpi.kpi[key].repeat.everyRepeat * futureCount,
                        1
                      )
                    );
                    let repeatStartNumFuture = repeatDateFuture.getMonth();
                    const repeatDateFutureConst = repeatDateFuture;
                    this.kpiArray[key] = {
                      name: dataKpi.kpi[key].nameLabel,
                      label: [],
                      value: [],
                    };
                    while (repeatDate.getTime() <= new Date().getTime()) {
                      if (q > 4) {
                        q = 1;
                      }
                      let label =
                        "Q" +
                        q +
                        "(" +
                        new Date(repeatDate).getFullYear() +
                        ")";
                      // let label = new Date(repeatDate).getDate()+' '+this.getMothFormat(new Date(repeatDate).getMonth())+''+new Date(repeatDate).getFullYear().toString().slice(2,4)
                      this.kpiArray[key].label.push(label);

                      let value = [];
                      for (
                        let index = 0;
                        index < res.data.obj.data.kpi.length;
                        index++
                      ) {
                        if (
                          typeof res.data.obj.data.kpi[index].kpi[key] !=
                          "undefined"
                        ) {
                          if (
                            new Date(
                              res.data.obj.data.kpi[index].kpi[key].lastUpdate
                            ).getTime() >= repeatDate.getTime() &&
                            new Date(
                              res.data.obj.data.kpi[index].kpi[key].lastUpdate
                            ).getTime() < repeatDateFuture.getTime()
                          ) {
                            value.push({
                              data: res.data.obj.data.kpi[index].kpi[key].input,
                              date: new Date(
                                res.data.obj.data.kpi[index].kpi[key].lastUpdate
                              ).getTime(),
                            });
                          }
                        }
                        //console.log(index)
                      }
                      if (value.length > 0) {
                        let sort = value.sort((a, b) => {
                          const modifier = -1;
                          if (a.date < b.date) return -1 * modifier;
                          if (a.date > b.date) return 1 * modifier;
                          return 0;
                        });
                        this.kpiArray[key].value.push(
                          sort[0].data !== null ? sort[0].data : 0
                        );
                      } else {
                        this.kpiArray[key].value.push(0);
                      }
                      //console.log('this.kpiArray[key].value',this.kpiArray[key].value)
                      repeatDate = new Date(
                        dataKpi.kpi[key].repeat.repeatStart
                      );
                      repeatDate.setMonth(
                        repeatStartNum +
                          dataKpi.kpi[key].repeat.everyRepeat * count,
                        1
                      );
                      repeatDateFuture = new Date(
                        dataKpi.kpi[key].repeat.repeatStart
                      );
                      repeatDateFuture.setMonth(
                        repeatStartNumFuture +
                          dataKpi.kpi[key].repeat.everyRepeat * futureCount,
                        1
                      );
                      q++;
                      count++;
                      futureCount++;
                    }
                  }
                });
                this.kpiAll.push(this.kpiArray);
              });
            }
          } else {
            this.allData = {};
            this.chartData = [];
            this.kpiAll = [];
            this.kpiArray = [];
          }
          setTimeout(() => {
            this.isLoadingPage = false;
          }, 1700);
        })
        .catch((e) => {
          this.isLoadingPage = false;
          console.log("api/get/cron/job/dashboard/error", e);
        });
    },
    fetchRangData() {
      this.isLoadingPage = true;
      let data = {
        underId: this.user.under,
        startRage: this.startRage,
        endRage: this.endRage,
      };

      HTTP.post("/get/dashboard", data)
        .then((res) => {
          //console.log('/get/dashboard',res)
          this.allData = res.data.obj;
          this.chartData.push(this.allData.company.inactive);
          this.chartData.push(this.allData.company.inprocess);
          this.chartData.push(this.allData.company.acheived);
          this.chartData.push(this.allData.company.deactive);
          this.chartData.push(this.allData.company.succeed);
          this.getInvestments();
          this.kpiAll = [];
          this.kpiArray = [];
          if (res.data.success && res.data.obj.kpi.length > 0) {
            res.data.obj.kpi.map((dataKpi, num) => {
              Object.keys(dataKpi.kpi).forEach((key) => {
                if (
                  dataKpi.kpi[key].repeat != null &&
                  typeof dataKpi.kpi[key].repeat != "undefined"
                ) {
                  let count = 1;
                  let futureCount = 1;
                  let repeatDate = new Date(
                    dataKpi.kpi[key].repeat.repeatStart
                  );
                  let repeatStartNum = repeatDate.getMonth();
                  let repeatDateFuture = new Date(
                    dataKpi.kpi[key].repeat.repeatStart
                  );
                  repeatDateFuture = new Date(
                    repeatDateFuture.setMonth(
                      repeatStartNum +
                        dataKpi.kpi[key].repeat.everyRepeat * futureCount,
                      1
                    )
                  );
                  let repeatStartNumFuture = repeatDateFuture.getMonth();
                  const repeatDateFutureConst = repeatDateFuture;
                  this.kpiArray[key] = {
                    name: dataKpi.kpi[key].nameLabel,
                    label: [],
                    value: [],
                  };
                  while (repeatDate.getTime() <= new Date().getTime()) {
                    let label =
                      new Date(repeatDate).getDate() +
                      " " +
                      this.getMothFormat(new Date(repeatDate).getMonth()) +
                      "" +
                      new Date(repeatDate).getFullYear().toString().slice(2, 4);
                    this.kpiArray[key].label.push(label);

                    let value = [];
                    for (
                      let index = 0;
                      index < res.data.obj.kpi.length;
                      index++
                    ) {
                      if (
                        typeof res.data.obj.kpi[index].kpi[key] != "undefined"
                      ) {
                        if (
                          new Date(
                            res.data.obj.kpi[index].kpi[key].lastUpdate
                          ).getTime() >= repeatDate.getTime() &&
                          new Date(
                            res.data.obj.kpi[index].kpi[key].lastUpdate
                          ).getTime() < repeatDateFuture.getTime()
                        ) {
                          value.push({
                            data: res.data.obj.kpi[index].kpi[key].input,
                            date: new Date(
                              res.data.obj.kpi[index].kpi[key].lastUpdate
                            ).getTime(),
                          });
                        }
                      }
                      //console.log(index)
                    }
                    if (value.length > 0) {
                      let sort = value.sort((a, b) => {
                        const modifier = -1;
                        if (a.date < b.date) return -1 * modifier;
                        if (a.date > b.date) return 1 * modifier;
                        return 0;
                      });
                      this.kpiArray[key].value.push(sort[0].data);
                    } else {
                      this.kpiArray[key].value.push(0);
                    }
                    //console.log('this.kpiArray[key].value',this.kpiArray[key].value)
                    repeatDate = new Date(dataKpi.kpi[key].repeat.repeatStart);
                    repeatDate.setMonth(
                      repeatStartNum +
                        dataKpi.kpi[key].repeat.everyRepeat * count,
                      1
                    );
                    repeatDateFuture = new Date(
                      dataKpi.kpi[key].repeat.repeatStart
                    );
                    repeatDateFuture.setMonth(
                      repeatStartNumFuture +
                        dataKpi.kpi[key].repeat.everyRepeat * futureCount,
                      1
                    );
                    count++;
                    futureCount++;
                  }
                }
              });
            });

            this.kpiAll.push(this.kpiArray);
          }
          setTimeout(() => {
            this.isLoadingPage = false;
          }, 1700);
        })
        .catch((e) => {
          this.isLoadingPage = false;
          console.log(e);
        });
    },
    async fetchData() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post("/api/get/fiscal/year/board/dashboard", {
        scienceParkId: this.user.scienceParkId,
      })
        .then((res) => {
          // console.log('api/get/cron/job/dashboard',res)
          if (res.data.success) {
            this.allData = res.data.obj.data;
            this.chartData.push(this.allData.company.inactive);
            this.chartData.push(this.allData.company.inprocess);
            this.chartData.push(this.allData.company.acheived);
            this.chartData.push(this.allData.company.deactive);
            this.chartData.push(this.allData.company.succeed);
            this.getInvestments();
            this.kpiAll = [];
            this.kpiArray = [];
            if (res.data.obj.data.kpi.length > 0) {
              res.data.obj.data.kpi.map((dataKpi, num) => {
                Object.keys(dataKpi.kpi).forEach((key) => {
                  if (
                    dataKpi.kpi[key].repeat != null &&
                    typeof dataKpi.kpi[key].repeat != "undefined"
                  ) {
                    let count = 1;
                    let futureCount = 1;
                    let repeatDate = new Date(
                      dataKpi.kpi[key].repeat.repeatStart
                    );
                    let repeatStartNum = repeatDate.getMonth();
                    let repeatDateFuture = new Date(
                      dataKpi.kpi[key].repeat.repeatStart
                    );
                    repeatDateFuture = new Date(
                      repeatDateFuture.setMonth(
                        repeatStartNum +
                          dataKpi.kpi[key].repeat.everyRepeat * futureCount,
                        1
                      )
                    );
                    let repeatStartNumFuture = repeatDateFuture.getMonth();
                    const repeatDateFutureConst = repeatDateFuture;
                    this.kpiArray[key] = {
                      name: dataKpi.kpi[key].nameLabel,
                      label: [],
                      value: [],
                    };
                    while (repeatDate.getTime() <= new Date().getTime()) {
                      let label =
                        new Date(repeatDate).getDate() +
                        " " +
                        this.getMothFormat(new Date(repeatDate).getMonth()) +
                        "" +
                        new Date(repeatDate)
                          .getFullYear()
                          .toString()
                          .slice(2, 4);
                      this.kpiArray[key].label.push(label);

                      let value = [];
                      for (
                        let index = 0;
                        index < res.data.obj.data.kpi.length;
                        index++
                      ) {
                        if (
                          typeof res.data.obj.data.kpi[index].kpi[key] !=
                          "undefined"
                        ) {
                          if (
                            new Date(
                              res.data.obj.data.kpi[index].kpi[key].lastUpdate
                            ).getTime() >= repeatDate.getTime() &&
                            new Date(
                              res.data.obj.data.kpi[index].kpi[key].lastUpdate
                            ).getTime() < repeatDateFuture.getTime()
                          ) {
                            value.push({
                              data: res.data.obj.data.kpi[index].kpi[key].input,
                              date: new Date(
                                res.data.obj.data.kpi[index].kpi[key].lastUpdate
                              ).getTime(),
                            });
                          }
                        }
                        //console.log(index)
                      }
                      if (value.length > 0) {
                        let sort = value.sort((a, b) => {
                          const modifier = -1;
                          if (a.date < b.date) return -1 * modifier;
                          if (a.date > b.date) return 1 * modifier;
                          return 0;
                        });
                        this.kpiArray[key].value.push(sort[0].data);
                      } else {
                        this.kpiArray[key].value.push(0);
                      }
                      //console.log('this.kpiArray[key].value',this.kpiArray[key].value)
                      repeatDate = new Date(
                        dataKpi.kpi[key].repeat.repeatStart
                      );
                      repeatDate.setMonth(
                        repeatStartNum +
                          dataKpi.kpi[key].repeat.everyRepeat * count,
                        1
                      );
                      repeatDateFuture = new Date(
                        dataKpi.kpi[key].repeat.repeatStart
                      );
                      repeatDateFuture.setMonth(
                        repeatStartNumFuture +
                          dataKpi.kpi[key].repeat.everyRepeat * futureCount,
                        1
                      );
                      count++;
                      futureCount++;
                    }
                  }
                });
              });

              this.kpiAll.push(this.kpiArray);
            }
          } else {
            this.allData = {};
            this.chartData = [];
            this.kpiAll = [];
            this.kpiArray = [];
          }
          setTimeout(() => {
            this.isLoadingPage = false;
          }, 1700);
        })
        .catch((e) => {
          this.isLoadingPage = false;
          console.log("api/get/cron/job/dashboard/error", e);
        });
    },
    getInvestments() {
      let data;
      this.labelName = [];
      this.labelvalue = [];
      this.labelvalue = [];
      this.invest = [];
      //console.log('this.allData.allInvestment',this.allData)
      this.categories.map((item) => {
        let approve = 0;
        let percent = 0;
        let approveAmount = 0;
        let amount = 0;
        data = this.allData.allInvestment.filter((search) => {
          return search.categoryId == item.id;
        });
        //console.log('data',data)
        if (data.length > 0) {
          data.map((data) => {
            if (data.approveAmount != null) {
              amount += data.approveAmount;
            }
          });

          approve += approve + amount;

          if (this.allData.approve == 0) {
            percent = 0;
          } else {
            approveAmount = this.allData.approve;
            percent = (amount * 100) / this.allData.approve;
          }
          //console.log(data[0].categoryId,'/',item.name,'/',percent,'/',approveAmount)
          this.invest.push({
            categoryId: data[0].categoryId,
            percent: percent,
            approveAmount: approveAmount,
            name: item.name,
            amount: amount,
            activities: data.length,
          });
          if (amount > 0) {
            this.labelName.push(item.name);
            //console.log('this.under.',this.under.underCode)
            if (
              this.under.underCode === "B001" ||
              this.under.underCode === "B002" ||
              this.getRule === "board"
            ) {
              this.labelvalue.push({ label: item.name, data: amount });
            } else {
              this.labelvalue.push({
                label: item.name,
                data: Number(percent.toFixed(2)),
              });
            }
          }
        }
      });
      //console.log('this.invest',this.invest,this.labelName,this.labelvalue)
    },
    changTap() {
      this.renderLineChart = false;
      this.isLoadingPage = true;
      setTimeout(() => {
        this.renderLineChart = true;
      }, 10);
      setTimeout(() => {
        this.isLoadingPage = false;
      }, 1500);
    },
    getMothFormat(month) {
      let text = "";
      switch (month) {
        case 0:
          text = "Jan";
          break;
        case 1:
          text = "Feb";
          break;
        case 2:
          text = "Mar";
          break;
        case 3:
          text = "Apr";
          break;
        case 4:
          text = "May";
          break;
        case 5:
          text = "Jun";
          break;
        case 6:
          text = "Jul";
          break;
        case 7:
          text = "Aug";
          break;
        case 8:
          text = "Sep";
          break;
        case 9:
          text = "Oct";
          break;
        case 10:
          text = "Nov";
          break;
        case 11:
          text = "Dec";
          break;
        default:
          break;
      }
      return text;
    },
    getColor() {
      var colorArray = [
        "#209cee",
        "#23d160",
        "#63b598",
        "#ce7d78",
        "#ea9e70",
        "#a48a9e",
        "#c6e1e8",
        "#648177",
        "#0d5ac1",
        "#f205e6",
        "#1c0365",
        "#14a9ad",
        "#4ca2f9",
        "#a4e43f",
        "#d298e2",
        "#6119d0",
        "#d2737d",
        "#c0a43c",
        "#f2510e",
        "#651be6",
        "#79806e",
        "#61da5e",
        "#cd2f00",
        "#9348af",
        "#01ac53",
        "#c5a4fb",
        "#996635",
        "#b11573",
        "#4bb473",
        "#75d89e",
        "#2f3f94",
        "#2f7b99",
        "#da967d",
        "#34891f",
        "#b0d87b",
        "#ca4751",
        "#7e50a8",
        "#c4d647",
        "#e0eeb8",
        "#11dec1",
        "#289812",
        "#566ca0",
        "#ffdbe1",
        "#2f1179",
        "#935b6d",
        "#916988",
        "#513d98",
        "#aead3a",
        "#9e6d71",
        "#4b5bdc",
        "#0cd36d",
        "#250662",
        "#cb5bea",
        "#228916",
        "#ac3e1b",
        "#df514a",
        "#539397",
        "#880977",
        "#f697c1",
        "#ba96ce",
        "#679c9d",
        "#c6c42c",
        "#5d2c52",
        "#48b41b",
        "#e1cf3b",
        "#5be4f0",
        "#57c4d8",
        "#a4d17a",
        "#225b8",
        "#be608b",
        "#96b00c",
        "#088baf",
        "#f158bf",
        "#e145ba",
        "#ee91e3",
        "#05d371",
        "#5426e0",
        "#4834d0",
        "#802234",
        "#6749e8",
        "#0971f0",
        "#8fb413",
        "#b2b4f0",
        "#c3c89d",
        "#c9a941",
        "#41d158",
        "#fb21a3",
        "#51aed9",
        "#5bb32d",
        "#807fb",
        "#21538e",
        "#89d534",
        "#d36647",
        "#7fb411",
        "#0023b8",
        "#3b8c2a",
        "#986b53",
        "#f50422",
        "#983f7a",
        "#ea24a3",
        "#79352c",
        "#521250",
        "#c79ed2",
        "#d6dd92",
        "#e33e52",
        "#b2be57",
        "#fa06ec",
        "#1bb699",
        "#6b2e5f",
        "#64820f",
        "#1c271",
        "#21538e",
        "#89d534",
        "#d36647",
        "#7fb411",
        "#0023b8",
        "#3b8c2a",
        "#986b53",
        "#f50422",
        "#983f7a",
        "#ea24a3",
        "#79352c",
        "#521250",
        "#c79ed2",
        "#d6dd92",
        "#e33e52",
        "#b2be57",
        "#fa06ec",
        "#1bb699",
        "#6b2e5f",
        "#64820f",
        "#1c271",
        "#9cb64a",
        "#996c48",
        "#9ab9b7",
        "#06e052",
        "#e3a481",
        "#0eb621",
        "#fc458e",
        "#b2db15",
        "#aa226d",
        "#792ed8",
        "#73872a",
        "#520d3a",
        "#cefcb8",
        "#a5b3d9",
        "#7d1d85",
        "#c4fd57",
        "#f1ae16",
        "#8fe22a",
        "#ef6e3c",
        "#243eeb",
        "#1dc18",
        "#dd93fd",
        "#3f8473",
        "#e7dbce",
        "#421f79",
        "#7a3d93",
        "#635f6d",
        "#93f2d7",
        "#9b5c2a",
        "#15b9ee",
        "#0f5997",
        "#409188",
        "#911e20",
        "#1350ce",
        "#10e5b1",
        "#fff4d7",
        "#cb2582",
        "#ce00be",
        "#32d5d6",
        "#17232",
        "#608572",
        "#c79bc2",
        "#00f87c",
        "#77772a",
        "#6995ba",
        "#fc6b57",
        "#f07815",
        "#8fd883",
        "#060e27",
        "#96e591",
        "#21d52e",
        "#d00043",
        "#b47162",
        "#1ec227",
        "#4f0f6f",
        "#1d1d58",
        "#947002",
        "#bde052",
        "#e08c56",
        "#28fcfd",
        "#bb09b",
        "#36486a",
        "#d02e29",
        "#1ae6db",
        "#3e464c",
        "#a84a8f",
        "#911e7e",
        "#3f16d9",
        "#0f525f",
        "#ac7c0a",
        "#b4c086",
        "#c9d730",
        "#30cc49",
        "#3d6751",
        "#fb4c03",
        "#640fc1",
        "#62c03e",
        "#d3493a",
        "#88aa0b",
        "#406df9",
        "#615af0",
        "#4be47",
        "#2a3434",
        "#4a543f",
        "#79bca0",
        "#a8b8d4",
        "#00efd4",
        "#7ad236",
        "#7260d8",
        "#1deaa7",
        "#06f43a",
        "#823c59",
        "#e3d94c",
        "#dc1c06",
        "#f53b2a",
        "#b46238",
        "#2dfff6",
        "#a82b89",
        "#1a8011",
        "#436a9f",
        "#1a806a",
        "#4cf09d",
        "#c188a2",
        "#67eb4b",
        "#b308d3",
        "#fc7e41",
        "#af3101",
        "#ff065",
        "#71b1f4",
        "#a2f8a5",
        "#e23dd0",
        "#d3486d",
        "#00f7f9",
        "#474893",
        "#3cec35",
        "#1c65cb",
        "#5d1d0c",
        "#2d7d2a",
        "#ff3420",
        "#5cdd87",
        "#a259a4",
        "#e4ac44",
        "#1bede6",
        "#8798a4",
        "#d7790f",
        "#b2c24f",
        "#de73c2",
        "#d70a9c",
        "#25b67",
        "#88e9b8",
        "#c2b0e2",
        "#86e98f",
        "#ae90e2",
        "#1a806b",
        "#436a9e",
        "#0ec0ff",
        "#f812b3",
        "#b17fc9",
        "#8d6c2f",
        "#d3277a",
        "#2ca1ae",
        "#9685eb",
        "#8a96c6",
        "#dba2e6",
        "#76fc1b",
        "#608fa4",
        "#20f6ba",
        "#07d7f6",
        "#dce77a",
        "#77ecca",
      ];
      return colorArray;
    },
  },
  async created() {
    this.isLoadingPage = true;
    await this.getUnder();
    await this.fetchRangDataCronJob();
  },

  computed: {
    kpiAllData() {
      let getKpi = {};
      if (Object.keys(this.kpiAll).length > 0) {
        Object.keys(this.kpiAll[this.kpiAll.length - 1]).forEach((key) => {
          getKpi[key] = {
            name: this.kpiAll[0][key].name,
            label: this.kpiAll[0][key].label,
            value: [],
            percent: 0,
          };
          for (let index = 0; index < this.kpiAll.length; index++) {
            for (let x = 0; x < this.kpiAll[index][key].value.length; x++) {
              let old = 0;
              if (getKpi[key].value.length > 0) {
                old =
                  typeof getKpi[key].value[x] !== "undefined"
                    ? getKpi[key].value[x]
                    : 0;
              }
              let sum = Number(this.kpiAll[index][key].value[x]) + Number(old);
              getKpi[key].value[x] = sum;
            }
            getKpi[key].percent = this.getPercentGrowth(
              getKpi[key].value[getKpi[key].value.length - 1],
              getKpi[key].value[getKpi[key].value.length - 2]
            );
          }
        });
        return getKpi;
      } else {
        return {};
      }
    },
    categories() {
      let dataCat = [];
      this.businessIncubator.map((item) => {
        dataCat.push(item);
      });
      this.supportAgencies.map((item) => {
        dataCat.push(item);
      });
      return dataCat;
    },
    businessIncubator() {
      return this.$store.state.businessIncubator;
    },
    supportAgencies() {
      return this.$store.state.supportAgencies;
    },
    getRule() {
      return this.$store.getters.getRule;
    },
    user() {
      return this.$store.state.user;
    },
    startupLists() {
      return this.$store.getters.startupLists;
    },
    batch() {
      return this.$store.state.batch;
    },
    businessType() {
      return this.$store.state.businessType;
    },
    token() {
      return this.$store.state.token;
    },
  },
};
</script>
<style scoped>
.h-100-per {
  height: 100%;
}
.box-h-max {
  padding: 20px;
  height: 100%;
}
.line-title-dh {
  border-bottom: 0.5px solid #d8d8d8;
}
.line-progress {
  background: #c7c7c7;
  height: 2px;
  margin-left: 2px;
  margin-right: 2px;
}
.line-progress-success {
  height: 5px;
  background-color: #00a79d;
  position: relative;
  top: 3px;
  border-radius: 10px;
}
.overdue-color {
  color: #ac1818;
}

.scrollChart {
  height: 477px;
  overflow-y: auto;
}
</style>